module.exports = __webpack_public_path__ + "imgs/shop2.95b206589b5c3e1ccee5ece990db28d2.svg";